import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import axios from "axios";
import { Button, Text } from "components";
import DashboardCards from "components/Cards/DashboardCards";
import InputFieldForm from "components/InputFields/InputFieldForm";
import GlobalLoading from "components/PageSkeleton/GlobalLoading";
import { pageSize } from "components/PaginationPageSize";
import SelectField from "components/SelectFeild.jsx/SelectField";
import AccessRightCard from "pages/AccessRight/AccessRightCard";
import Pagination from "pages/Pagination/Pagination";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { useEffect, useRef, useState } from "react";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { FaCheckCircle, FaChevronRight, FaVial } from "react-icons/fa";
import { FaFlaskVial } from "react-icons/fa6";
import { MdCancel, MdClose, MdPendingActions } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { RADIOLOGY_ORDER_STATUS, Service_Category } from "../../Constants/constants";
pdfMake.vfs = pdfFonts.pdfMake?.vfs;


const RadiologyOrderWorklist = () => {
    const gridRef = useRef();
    const navigate = useNavigate();
    const token = sessionStorage.getItem("token");
    const [selectedLab, setSelectedLab] = useState(null);
    const [visible, setVisible] = useState(false);
    const [cardsLoading, setCardsLoading] = useState(false);
    const [cardsData, setCardsData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [rowData, setRowData] = useState([]);
    const [doclist, setdoclist] = useState([]);
    const [page, setPage] = useState(1);
    const [count, setCount] = useState();
    const [labList, setLabList] = useState([]);
    const [searchParameter2, setsearchParameter2] = useState("");
    const [formDate, setFormDate] = useState("");
    const [specimen, setSpecimen] = useState([]);
    const [recordPerPage, setRecordPerPage] = useState(pageSize);




    const selectRef = useRef(null);
    let today = new Date();
    today.setDate(today.getDate() + 1);

    const customStyle = {
        height: "100%",
        width: "100%",
        fontSize: "12px",
    };
    const [
        searchHospitalSpecificCriteriaId,
        setsearchHospitalSpecificCriteriaId,
    ] = useState();

    const [
        search_hospital_specific_date_range_id,
        setsearchHospitalSpecificDateRangeId,
    ] = useState();

    const [searchCompanySpecificCriteria, setsearchCompanySpecificCriteria] =
        useState([]);

    const [searchcompanyspecificdaterange, setsearchcompanyspecificdaterange] =
        useState([]);






    const headers = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    useEffect(() => {
        const storeddoclist = sessionStorage.getItem("docAccesslist");
        if (storeddoclist) {
            try {
                const parseddoclist = JSON.parse(storeddoclist);
                setdoclist(parseddoclist);
            } catch (error) {
                // console.error("Error parsing JSON:", error);
            }
        }
    }, []);

    const viewAccess = doclist.some(
        (item) => item.hospital_module_id === 75 && item.view,
    );
    const updateAccess = doclist.some(
        (item) => item.hospital_module_id == 75 && item.update
    );


    useEffect(() => {
        selectRef.current = document.body;
    }, []);




    const getrowData = async () => {
        try {
            const request = {
                hospital_lab_id: 0,
                radiology_order_status_id: RADIOLOGY_ORDER_STATUS.PENDING,
                search_parameter: searchParameter2 || null,
                search_hospital_specific_date_range_id:
                    search_hospital_specific_date_range_id || null,
                search_parameter_date: formDate || null,
                isactive: true,
                offset: (page - 1) * recordPerPage,
                limit: recordPerPage,
            };

            const res = await axios.post(
                "/api/doctor/radiology-order/get",
                request,
                headers
            );

            // console.log("lab orders", res.data);

            setRowData(res.data);

            if (res.data.length > 0) {
                setCount(res.data[0].count);
            } else {
                setCount(0);
            }

        } catch (err) {
            // console.log(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getrowData();
    }, [
        page,
        recordPerPage,
        searchParameter2,
        selectedLab,
        search_hospital_specific_date_range_id,
        formDate
    ]);


    const getLabList = async () => {
        try {
            const res = await axios.post(
                "/api/doctor/hospital-lab/get",
                { service_category_id: Service_Category.LAB_TEST },
                headers
            );

            const formatted = res.data.map((lab) => ({
                value: lab.id,
                label: lab.name,
            }));

            setLabList(formatted);

        } catch (err) {
            // console.log(err);
        }
    };

    useEffect(() => {
        getLabList();
    }, []);

    const getsearchHospitalSpecificDateRangeList = async () => {
        try {
            const res = await axios.post(
                "/api/doctor/searchhospitalspecificdaterange/get",
                {},
                headers
            );

            const formatted = res.data.map((data) => ({
                value: data.search_date_range_id,
                label: data.date_range,
            }));

            setsearchcompanyspecificdaterange(formatted);

            // console.log(res.data);


        } catch (err) {
            // console.log(err);
        }
    };

    useEffect(() => {
        getsearchHospitalSpecificDateRangeList();
    }, []);




    const ColDefaultVale = { filter: true };

    const labOrderColumnDefs = [
        {
            headerName: "Sr No",
            field: "sr",
            minWidth: 80,
            maxWidth: 90,
        },
        {
            headerName: "Order Date",
            field: "createdon",
            minWidth: 150,
            flex: 1,
            valueFormatter: (params) => {
                if (!params.value) return "";

                const date = new Date(params.value);

                return date.toLocaleDateString("en-GB");
            }
        },
        {
            headerName: "Code",
            field: "code",
            minWidth: 140,
            flex: 1,
        },
        {
            headerName: "UHID",
            field: "prn",
            minWidth: 120,
            flex: 1,
        },
        {
            headerName: "Patient Name",
            field: "patient_name",
            minWidth: 180,
            flex: 1.5,
        },
        {
            headerName: "Gender",
            field: "patient_gender",
            minWidth: 90,
            flex: 1,
        },
        {
            headerName: "Birthdate",
            field: "patient_birthdate",
            minWidth: 120,
            flex: 1,
        },
        {
            headerName: "Lab Name",
            field: "hospital_lab_name",
            minWidth: 150,
            flex: 1.2,
        },
        {
            headerName: "Address",
            field: "patient_address",
            minWidth: 250,
            flex: 2,
        },

        {
            headerName: "Open Worklist",
            field: "id",
            width: 140,
            pinned: "right",
            sortable: false,
            filter: false,
            cellStyle: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            },
            cellRenderer: (params) =>
                updateAccess ? (
                    <button
                        type="button"
                        onClick={() => {
                            navigate(`/radiologyworklist/${params.data.id}`, {
                                state: params.data,
                            });
                        }}
                        className="btn-active px-3 py-1 rounded-md border border-blue-200 bg-blue-50 hover:bg-blue-100 text-sm font-medium whitespace-nowrap flex items-center gap-1"
                    >
                        Open Worklist
                        <FaChevronRight className="w-3 h-3" />
                    </button>
                ) : (
                    <span
                        className="flex justify-center items-center h-10 p-1 w-16 cursor-not-allowed"
                        title="You don't have permission to update"
                    >
                        <button className="btn-active opacity-40 blur-[1px] px-3 py-1 rounded-md border border-blue-200 bg-blue-50 hover:bg-blue-100 text-sm font-medium whitespace-nowrap flex items-center gap-1">
                            Open Worklist
                            < FaChevronRight className="w-3 h-3" />
                        </button >
                    </span >
                ),
        },
    ];

    useEffect(() => {
        const getRadiologyOrderSummary = async () => {
            setCardsLoading(true);
            try {
                const response = await axios.post(
                    "/api/doctor/ipdpatient/radiologyordersummary/get",
                    {},
                    headers
                );

                setCardsData(response.data.radiology_order_summary?.[0]);
                // console.log(response.data.lab_order_summary?.[0]);

            } catch (error) {
                // console.error(error);
            }
            finally {
                setCardsLoading(false);
            }
        };

        getRadiologyOrderSummary();
    }, []);


    const dashboardCards = [
        {
            id: "pending",
            title: "Pending Assignment",
            value: cardsData?.total_radiology_order_pending,
            icon: MdPendingActions,
            color: "#F59E0B",
        },
        {
            id: "progress",
            title: "In Progress",
            value: cardsData?.total_radiology_order_inprogress,
            icon: AiOutlineLoading3Quarters,
            color: "#8B5CF6",
        },
        {
            id: "completed",
            title: "Report Finalized",
            value: cardsData?.total_radiology_order_report_finalized,
            icon: FaCheckCircle,
            color: "#16A34A",
        },
        {
            id: "cancelled",
            title: "Cancelled",
            value: cardsData?.total_radiology_order_cancelled,
            icon: MdCancel,
            color: "#EF4444",
        },
    ];


    // api for specimen type 
    const getSpecimen = async () => {
        try {
            const res = await axios.post(
                "/api/doctor/specimen/get",
                {},
                headers,
            );
            const options = res.data
                .map((item) => ({
                    value: item.id,
                    label: item.name,
                }));
            // console.log("specimen options", options);

            setSpecimen(options);

        } catch {
            // toast.error("Failed to load data", {
            //     autoClose: 1000,
            // });
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        getSpecimen();
    }, []);


    return (
        <>
            <ToastContainer />
            {viewAccess ? (
                <div className="px-2">
                    <div className="page-header">
                        <div className="page-header-left">
                            <FaFlaskVial className="page-logo" />
                            <Text className="page-title">
                                Radiology Worklist
                            </Text>
                        </div>
                    </div>
                    {/*  cards div */}
                    <DashboardCards
                        cards={dashboardCards}
                        loading={cardsLoading}
                    />
                    <div className="flex flex-row  justify-center border rounded-lg pt-2 px-2 gap-2  shadow-sm">

                        {/* Search */}
                        <InputFieldForm
                            // label="Search"
                            placeholder="Search By Order No / Patient / PRN"
                            value={searchParameter2}
                            onChange={(e) => {
                                setsearchParameter2(e.target.value);
                                setPage(1);
                            }}
                        />

                        {/* Lab */}
                        <SelectField
                            // label="Lab"
                            name="hospital_lab_id"
                            placeholder="Select Lab"
                            placeholderFontSize={"12px"}
                            options={labList}
                            value={selectedLab?.value || ""}
                            onChange={(e) => {
                                const lab = labList.find(
                                    x => x.value === Number(e.target.value)
                                );
                                setSelectedLab(lab);
                                setPage(1);
                            }}
                        />

                        {/* Date Range */}
                        <SelectField
                            // label="Date Range"
                            name="date_range"
                            placeholder="Select Date Range"
                            placeholderFontSize={"12px"}
                            options={searchcompanyspecificdaterange}
                            value={search_hospital_specific_date_range_id || ""}
                            onChange={(e) => {
                                setsearchHospitalSpecificDateRangeId(
                                    Number(e.target.value)
                                );
                                setPage(1);
                            }}
                        />

                        {/* Custom Date */}
                        {search_hospital_specific_date_range_id === 7 && (
                            <InputFieldForm
                                type="date"
                                // label="Custom Date"
                                placeholder="Select Custom Date"
                                value={formDate}
                                onChange={(e) => {
                                    setFormDate(e.target.value);
                                    setPage(1);
                                }}
                            />
                        )}

                        {/* Buttons */}

                        <div >
                            <button
                                type="button"
                                className="btn-primary !mt-0.5"
                                onClick={() => getrowData()}
                            >
                                Search
                            </button>
                        </div>

                        <div>
                            <button
                                type="button"
                                className="btn-secondary !mt-0.5"
                                onClick={() => {
                                    setsearchParameter2("");
                                    setSelectedLab(null);
                                    setsearchHospitalSpecificDateRangeId(null);
                                    setFormDate("");
                                    setPage(1);
                                }}
                            >
                                Reset
                            </button>
                        </div>


                    </div>

                    {/* ag grid and header div */}
                    <div className="flex gap-4 w-full mt-1">
                        {/* ag grid and header div */}
                        <div
                            className={`transition-all duration-300 ${visible ? "w-[60%]" : "w-full"
                                }`}
                        >

                            <GlobalLoading isLoading={loading}>
                                <div className="w-full h-[calc(100vh-253px)]">
                                    <div
                                        className="ag-theme-quartz"
                                        style={customStyle}
                                    >
                                        <AgGridReact
                                            ref={gridRef}
                                            rowData={rowData.map((row, index) => ({
                                                ...row,
                                                sr: (page - 1) * recordPerPage + index + 1,
                                            }))}
                                            columnDefs={labOrderColumnDefs}
                                            defaultColDef={ColDefaultVale}
                                            suppressMenuHide={true}
                                            suppressExcelExport={true}
                                            overlayLoadingTemplate={
                                                loading ? "Loading..." : null
                                            }
                                            overlayNoRowsTemplate={
                                                loading
                                                    ? '<img class="animate-spin" src="https://www.svgrepo.com/show/199956/loading-loader.svg" style="width:50px;height:50px;" />'
                                                    : "No Pending Requests Found"
                                            }
                                        />
                                    </div>
                                </div>

                                <Pagination
                                    count={count}
                                    setRecordPerPage={setRecordPerPage}
                                    recordPerPage={recordPerPage}
                                    setLoading={setLoading}
                                    setData={setRowData}
                                    setPage={setPage}
                                    page={page}
                                />
                            </GlobalLoading>
                        </div>
                        {/* Right Drawer */}
                        {/* {visible && (
                            <div
                                className=" w-[40%] bg-white-A700 border-l shadow-lg transition-all duration-300 overflow-auto ">
                                {form}
                            </div>
                        )} */}
                    </div>

                </div>


            ) : (
                <AccessRightCard />
            )}
        </>
    );
};

export default RadiologyOrderWorklist;
